import { OECTagType, OECRetrainStepProgress } from '../../types';
export const getThemesPerResponse = themes => {
  const responsesWithThemes = {};
  // function to update the responses with the new theme
  const addThemeToResponse = (responseTextId, themeId, tagType) => {
    const newTheme = {
      id: themeId,
      tagType
    };
    if (responseTextId in responsesWithThemes) {
      responsesWithThemes[responseTextId] = [...responsesWithThemes[responseTextId], newTheme];
    } else {
      responsesWithThemes[responseTextId] = [newTheme];
    }
  };
  themes.forEach(theme => {
    var _a;
    // add manually generated theme to each response
    theme.responseTextIds.forEach(responseTextId => {
      addThemeToResponse(responseTextId, theme.id, OECTagType.OECUSER);
    });
    // add autogenerated themes to each response
    (_a = theme.autogeneratedTag) === null || _a === void 0 ? void 0 : _a.responseTextIds.forEach(responseTextId => {
      var _a;
      const themeId = (_a = theme.autogeneratedTag) === null || _a === void 0 ? void 0 : _a.id;
      if (themeId) {
        addThemeToResponse(responseTextId, themeId, OECTagType.OECMODEL);
      }
    });
  });
  return responsesWithThemes;
};
export const calculateTrainingCounts = ({
  responses,
  responsesTotal,
  themesTotal
}) => {
  const responseTextIds = Object.keys(responses);
  const counts = {
    responseCount: responsesTotal,
    themesCount: themesTotal,
    autoTaggedCount: 0,
    manualTaggedCount: 0,
    untaggedCount: responsesTotal - responseTextIds.length
  };
  responseTextIds.forEach(responseTextId => {
    const themes = responses[responseTextId];
    // update manual count
    if (themes.some(t => t.tagType === OECTagType.OECUSER)) {
      counts.manualTaggedCount += 1;
    }
    // update autotagged count
    if (themes.some(t => t.tagType === OECTagType.OECMODEL)) {
      counts.autoTaggedCount += 1;
    }
  });
  return counts;
};
export const isRetrainStepHidden = progress => {
  return progress === OECRetrainStepProgress.HIDE_STEP;
};
export const isRetrainStepInProgress = progress => {
  return progress === OECRetrainStepProgress.STEP_IN_PROGRESS;
};
export const isRetrainStepComplete = progress => {
  return progress === OECRetrainStepProgress.STEP_COMPLETE;
};
// check if user has completed all required retrain steps
export const retrainStepsHaveBeenCompleted = steps => {
  // if all steps are hidden they haven't worked through any steps
  if (steps.every(step => isRetrainStepHidden(step))) {
    return false;
  }
  // ensure there are no remaining in progress steps
  return !steps.some(step => isRetrainStepInProgress(step));
};
export const retrainProgressHandler = ({
  value,
  progressValue,
  themesChanged,
  responsesChanged,
  setProgressValue
}) => {
  // themes are unchanged, so no step in progress
  if (!themesChanged && !responsesChanged) {
    if (!isRetrainStepHidden(progressValue)) {
      setProgressValue(OECRetrainStepProgress.HIDE_STEP);
    }
    return;
  }
  // user has to take some action to move ahead with retraining
  if (value && (isRetrainStepHidden(progressValue) || isRetrainStepComplete(progressValue))) {
    setProgressValue(OECRetrainStepProgress.STEP_IN_PROGRESS);
  }
  // user has completed the action to move ahead with retraining
  if (!value && isRetrainStepInProgress(progressValue)) {
    setProgressValue(OECRetrainStepProgress.STEP_COMPLETE);
  }
};